import { Environment } from "./environment.type";

export const environment: Environment = {
  production: false,
  useEmulator: false,
  google:{
    places: "AIzaSyBdRYdEUS7GzX5-q5c3inbRuffe4FZ8G1U",
  },
  stripe: {
    key: "pk_test_51SG69WCrlliAMkiwhIC3hROenpEeoyDcrEFToN5ulnkW6eDq4uRGNaXyn8yI0rSCdwVc81W6OqGPQlQWjmk7aViY00LA9l7ZM4",
  },
  firebase: {
    apiKey: "AIzaSyA5h374kvI6LuSuI0PFFvAei7-DpI7CjpM",
    authDomain: "mobile-storehouse-dev.firebaseapp.com",
    projectId: "mobile-storehouse-dev",
    storageBucket: "mobile-storehouse-dev.firebasestorage.app",
    messagingSenderId: "618818216704",
    appId: "1:618818216704:web:1c4d161210219785d989e5",
    measurementId: "G-NK3ZP7Z6FX"
  },
  listingPlaceHolderImageId: "736af975c32948ca960324f102699714",
};